import { FC } from 'react';

import { isNumber } from 'lodash';
import { NON_BREAKING_SPACE } from 'utils/constants/common';

import { formatNumber } from '@hh.ru/front-static-app';
import { Skeleton, Text, TextTypography } from '@hh.ru/magritte-ui';

import { CELL_TYPOGRAPHY, EMPTY_VALUE } from 'components/CampaignsDashboard/utils/constants';

interface CampaignTableNumberProps {
    value?: number;
    formatValue?: (value: number) => string;
    loading?: boolean;
    typography?: TextTypography;
}

const formatTableNumber = (value: number): string => formatNumber(value, { groupSeparator: NON_BREAKING_SPACE });

export const CampaignTableNumber: FC<CampaignTableNumberProps> = ({
    value,
    formatValue = formatTableNumber,
    loading = false,
    typography = CELL_TYPOGRAPHY,
}) => {
    return (
        <Text typography={typography}>
            <Skeleton height={16} width={60} borderRadius={8} loading={loading}>
                {isNumber(value) ? formatValue(value) : EMPTY_VALUE}
            </Skeleton>
        </Text>
    );
};
